import { render } from "./ui-select.vue?vue&type=template&id=269ece36&ts=true"
import script from "./ui-select.vue?vue&type=script&lang=ts"
export * from "./ui-select.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1fe6d5c2-02f8-4b7b-a7ed-3827401bba29/workspace/toilet-go-front_Ak2Q/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__